import React, { useContext } from "react";
import { EtatGlobalContext, CABINETS_LM } from "../../EtatGlobal";

// Remplace l'ancien champ libre "Lieu du site du collaborateur" dans les
// formulaires LM : la sélection du cabinet alimente la page de garde
// (lieu_collab = ville) et le pied de page juridique des LM (7 champs
// docxtemplater denomination_cab/forme_cab/capital_cab/siege_cab/siren_cab/
// siret_cab/ville_rcs_cab), injectés directement dans formData sans
// affichage — ce sont des constantes CABINETS_LM, non éditables.
function CabinetSelect() {
  const { formData, setFormData, cabinetRequisVisible, setCabinetRequisVisible } =
    useContext(EtatGlobalContext);

  const cabinetChoisi = Object.prototype.hasOwnProperty.call(
    CABINETS_LM,
    formData.lieu_collab,
  );

  // L'état "champ requis" (rouge) n'apparaît qu'après une tentative
  // d'enregistrement/soumission sans cabinet, jamais à l'ouverture.
  const enErreur = cabinetRequisVisible && !cabinetChoisi;

  const handleSelect = (e) => {
    const ville = e.target.value;
    const cabinet = CABINETS_LM[ville];
    if (ville) setCabinetRequisVisible(false);
    setFormData((prev) => ({
      ...prev,
      lieu_collab: ville || " ",
      ...(cabinet || {}),
    }));
  };

  return (
    <>
      <div>
        <label className="text-slate-600 mb-1 block text-xs">
          Sélection du cabinet : <span className="text-red-500">*</span>
        </label>
        <select
          name="lieu_collab"
          value={cabinetChoisi ? formData.lieu_collab : ""}
          onChange={handleSelect}
          className={`bg-white border h-9 text-sm rounded-md px-3 w-full text-slate-700 outline-none transition-all ${
            enErreur
              ? "border-red-400 ring-1 ring-red-100 focus:border-red-500"
              : "border-slate-200 focus:border-[#840040]/40"
          }`}
        >
          <option value="">— Sélectionner un cabinet —</option>
          {Object.keys(CABINETS_LM).map((ville) => (
            <option key={ville} value={ville}>
              {ville}
            </option>
          ))}
        </select>
        {enErreur && (
          <p className="text-[11px] text-red-500 mt-1 m-0">
            Champ obligatoire : sélectionnez le cabinet porteur de la lettre de
            mission.
          </p>
        )}
      </div>
    </>
  );
}

export default CabinetSelect;
